// Mock data for historical maps
// Casa Luchian watermark logo URL
export const CASA_LUCHIAN_LOGO = 'https://customer-assets.emergentagent.com/job_2b4a237d-dc72-4d0c-bcb5-ec5e02ecfe2b/artifacts/b6qsy3bl_8148f6aa-65a3-4d97-9f03-d04486ba40e7.png';
export const CASA_CARTARUM_LOGO = '/images/logo_casa_cartarum.png';

export const historicalMaps = [
  // ... (keeping original structure but it's not used by gallery anymore as it fetches from API)
  // But updating logo constant is crucial here as Navbar uses it
];
